var _rect, _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 342,
    viewBox: "0 0 76 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 341.26,
    fill: "#242A6B"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-45.4544 115.099L52.0861 56.6021C80.0273 43.8854 96.7921 49.4808 103.396 73.8969C103.396 108.486 103.396 149.688 103.396 198.521C103.396 224.463 96.2841 241.757 82.0594 250.913C67.8348 260.069 28.717 282.959 -35.802 319.583C-60.1871 329.248 -74.9198 321.109 -79.492 295.676C-80 253.457 -80.508 198.521 -78.984 165.966C-78.4759 142.058 -67.2994 125.272 -45.4544 115.099Z",
    fill: "url(#paint0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-11.4167 136.462L86.6318 77.9657C114.573 65.249 131.338 70.8443 137.942 95.2604C137.942 129.85 137.942 171.052 137.942 219.884C137.942 245.826 130.83 263.121 116.605 272.277C102.381 281.433 62.7547 304.323 -1.76425 340.947C-26.1494 350.612 -40.882 342.473 -45.4542 317.04C-45.4542 274.82 -45.9623 219.884 -44.4382 187.329C-43.9302 163.422 -32.7537 146.636 -11.4167 136.462Z",
    fill: "url(#paint1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7308 159.352L127.779 100.856C155.721 88.1389 172.485 93.7342 179.09 118.15C179.09 152.74 179.09 193.942 179.09 242.774C179.09 268.716 171.977 286.011 157.753 295.167C143.528 304.323 103.902 327.213 39.3832 363.837C14.9981 373.502 0.265429 365.363 -4.30678 339.93C-4.30678 297.71 -5.32282 242.774 -3.29073 210.219C-2.78271 186.82 8.39381 170.034 29.7308 159.352Z",
    fill: "url(#paint2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 117,
    width: 184,
    height: 275
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0955 117.597H222V391.26H38.0955V117.597Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6411 182.711L170.182 124.214C198.123 111.497 214.888 117.093 221.492 141.509C221.492 176.098 221.492 217.3 221.492 266.133C221.492 292.075 214.38 309.369 200.155 318.525C185.93 327.681 146.813 350.571 82.2935 387.196C57.9084 396.86 43.1758 388.722 38.6035 363.288C38.0955 321.069 37.5875 266.133 39.1116 233.578C39.6196 209.67 50.7961 192.884 72.6411 182.711Z",
    fill: "url(#paint3)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: -68.3475,
    y1: 132.668,
    x2: 92.6995,
    y2: 241.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1",
    x1: -33.8982,
    y1: 154.107,
    x2: 127.144,
    y2: 262.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2",
    x1: 7.10241,
    y1: 177.192,
    x2: 168.147,
    y2: 285.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818991,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3",
    x1: 49.748,
    y1: 200.28,
    x2: 210.795,
    y2: 308.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819362,
    stopColor: "#7AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7244,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 341.26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBg);
export default __webpack_public_path__ + "static/media/bottom-bg.c693b24a2357fd635e3421d736df2a11.svg";
export { ForwardRef as ReactComponent };